<template>
  <div
    class="progress-bar-container"
    :data-testid="dataTestId"
  >
    <div class="flex justify-between mb-2">
      <span class="text-sm font-medium text-gray-700">{{ label || 'Fortschritt' }}</span>
      <span class="text-sm font-medium text-blue-600">
        {{ currentStep }} von {{ totalSteps }}
      </span>
    </div>
    <div class="w-full bg-gray-200 rounded-full h-2.5">
      <div
        class="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-in-out"
        :style="{ width: `${(currentStep / totalSteps) * 100}%` }"
        :aria-valuenow="currentStep"
        :aria-valuemin="1"
        :aria-valuemax="totalSteps"
        role="progressbar"
        :aria-label="`Schritt ${currentStep} von ${totalSteps}`"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  currentStep: {
    type: Number,
    required: true
  },
  totalSteps: {
    type: Number,
    required: true
  },
  label: {
    type: String,
    default: ''
  },
  dataTestId: {
    type: String,
    default: 'progress-bar'
  }
});
</script>
